// extracted by mini-css-extract-plugin
module.exports = {"container":"_1FO5dOO"};